import { ArrowLeft, SparklesIcon } from 'lucide-react';

import { Button } from 'components/Button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'components/Tooltip';
import { Flex } from 'components/layout';
import { Typography } from 'components/typography';
import { StopTypes } from 'types/Appointment';

type EmailSchedulingHeaderProps = {
  onScheduleAnotherWay: () => void;
  showAIFilled?: boolean;
  stopType: StopTypes;
};

export default function EmailSchedulingHeader({
  onScheduleAnotherWay,
  showAIFilled,
  stopType,
}: EmailSchedulingHeaderProps) {
  return (
    <TooltipProvider>
      <Flex direction='col' gap='none' className='mb-4'>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant='ghost'
              size='sm'
              onClick={onScheduleAnotherWay}
              className='p-0.5 hover:border-opacity-0 gap-1 group mb-2'
              buttonNamePosthog={null}
            >
              <ArrowLeft className='h-5 w-5' />
              <Typography
                variant='body-xs'
                weight='medium'
                className='group-hover:text-neutral-600 hover:underline'
              >
                Schedule another way
              </Typography>
            </Button>
          </TooltipTrigger>
          <TooltipContent side='top' className='rounded-md ml-2 max-w-[260px]'>
            <Typography variant='body-xs'>
              Schedule using a supported website integration
            </Typography>
          </TooltipContent>
        </Tooltip>

        <Flex align='center' gap='xs' className='mb-2'>
          <Typography variant='h5' weight='semibold'>
            Email Request
          </Typography>

          {showAIFilled && (
            <Tooltip>
              <TooltipTrigger asChild>
                <span
                  className='inline-flex items-center ml-1 gap-1'
                  role='img'
                  aria-label='AI filled'
                >
                  <SparklesIcon
                    className='h-3 w-3 stroke-accent! opacity-75'
                    strokeWidth={2}
                  />
                  <Typography
                    variant='body-xs'
                    className='text-accent-main opacity-75 font-medium'
                  >
                    AI-filled
                  </Typography>
                </span>
              </TooltipTrigger>
              <TooltipContent
                side='top'
                className='rounded-md mr-2 max-w-[240px]'
              >
                <Typography variant='body-xs'>
                  This email was automatically filled using AI based on your
                  previous interactions.
                </Typography>
              </TooltipContent>
            </Tooltip>
          )}
        </Flex>

        <Typography variant='body-xs' textColor='muted'>
          Send an email to the{' '}
          {stopType === StopTypes.Pickup ? 'pickup' : 'dropoff'} recipient
        </Typography>
      </Flex>
    </TooltipProvider>
  );
}
